import {
    ADD_CATEGORIAS, 
    ORDENA_STATE_A_Z, 
    ORDENA_STATE_Z_A
} from './mutation-types'

import categoriaService from '@/services/menu/menuCategoriaDeProdutoService'

export default {
    buscarCategorias({ commit , state}){
        if(state.buscouTodasAsCategorias){
            return;
        }
        categoriaService.buscarCategorias()
            .then(res => {
                commit(ADD_CATEGORIAS, res.data);
            })
            .catch(error => {
                const { data } = error.response;
                console.log(data);
            })
    },
    ordenarDeAaZ({ commit }){
        commit(ORDENA_STATE_A_Z)
    },
    ordenarDeZaA({ commit }){
        commit(ORDENA_STATE_Z_A)
    }
}